import React from 'react'
import {makeStyles} from '@material-ui/styles';
import Button from "../../Button";
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    root: {
        bottom: 100,
        left: '100%',
        zIndex: theme.zIndex.appBar - 1,
        position: "fixed",
        transform: "rotate(-90deg) translateY(-76%)",
        whiteSpace: "nowrap",
        transformOrigin: "0% 0%",
        padding: "0 24px",
        fontSize: "0.7rem"
    }
}))

function FeedbackContentClosed(
    {
        setOpen,
        poll

    }) {
    const classes = useStyle();
    return (
        <Button variant="contained"  className={classes.root} onClick={() => setOpen(true)}>
            {poll.title}
        </Button>
    )
}

FeedbackContentClosed.propTypes = {
    setOpen: PropTypes.func.isRequired,
    poll: PropTypes.shape({
        title: PropTypes.string.isRequired,
        question: PropTypes.string.isRequired,
        openQuestion: PropTypes.string
    }).isRequired,
}


export default FeedbackContentClosed;
